module.exports = global["ReactDOM"] = require("-!/Users/bobylito/source/instantsearch.js/node_modules/react-dom/index.js");


//////////////////
// WEBPACK FOOTER
// ./~/react-dom/index.js
// module id = 375
// module chunks = 0